import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from './services/session.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router: Router = inject(Router);
  // const sessionService: SessionService = inject(SessionService);
  // let loggedIn = false;
  // sessionService.loggedIn.subscribe(async (status) => {
  //   loggedIn = status;
  // })
  // if (loggedIn) { return true }
  return router.parseUrl('/login');
}